import { Badge, Card, Dialog, Flex, Text } from "@radix-ui/themes";

import type { OrderDetailViewModel } from "./OrderDetailDialog.utils";
import { ORDERS_UNAVAILABLE_VALUE } from "./OrdersWidget.utils";

export interface OrderDetailDialogHeaderPresentationProps {
  title: string;
  description: string;
  detail?: OrderDetailViewModel;
}

const DetailHero = ({ detail }: { detail: OrderDetailViewModel }) => (
  <Card data-testid="order-detail-hero" mt="3" size="1" variant="surface">
    <Flex align="center" gap="3" wrap="wrap">
      {detail.heroFields.map((field) => (
        <Flex key={field.label} align="center" gap="1">
          <Text size="1" color="gray">
            {field.label}
          </Text>
          {field.value === ORDERS_UNAVAILABLE_VALUE ? (
            <Text size="1" color="gray">
              {field.value}
            </Text>
          ) : (
            <Badge color={field.badgeColor} variant="soft">
              {field.value}
            </Badge>
          )}
        </Flex>
      ))}
    </Flex>
  </Card>
);

export const OrderDetailDialogHeaderPresentation = ({
  title,
  description,
  detail,
}: OrderDetailDialogHeaderPresentationProps) => (
  <>
    <Dialog.Title>{title}</Dialog.Title>
    <Dialog.Description size="2" color="gray">
      {description}
    </Dialog.Description>
    {detail ? <DetailHero detail={detail} /> : null}
  </>
);
